export type NotificationPresetOption = {
  value: string;
  label: string;
  title: string;
  message: string;
};

export const notificationPresetOptions: NotificationPresetOption[] = [
  {
    value: 'kickoff',
    label: 'Picks Reminder',
    title: '📝 PCKM Soon!',
    message: "Don't forget to make your picks before kickoff",
  },
  {
    value: 'last-call',
    label: 'Last call',
    title: '⚠️ Last Call ⚠️ ',
    message: '',
  },
  {
    value: 'custom',
    label: 'Custom message',
    title: 'League Update',
    message: '',
  },
];
